/**
 * Normalisation d'un mot MOTUS (spec games/motus §3.2). Fonction pure, testée.
 * Majuscule + suppression des diacritiques (les accents sont combinants → longueur
 * préservée : É→E). Utilisée côté serveur (validation) et front (affichage/saisie).
 */
export function normalizeWord(raw: string): string {
  return raw
    .trim()
    .toUpperCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');
}

/** Vrai si `normalized` est exactement `length` lettres A–Z (forme valide). */
export function isWordShapeValid(normalized: string, length: number): boolean {
  return normalized.length === length && /^[A-Z]+$/.test(normalized);
}
